/**
 *
 * @param {string} label - label text for input
 * @param {string} name - name attribute
 * @param {string} id - id attribute
 * @param value - textarea value
 * @param {Function} handleChange - change event handler
 * @param {string} labelClassName - CSS Classses for <label>
 * @param {string} inputClassName - CSS Classses for <input/>
 * @returns A <label> + <textarea>
 */
const Textarea = ({
  id,
  name,
  label,
  value,
  labelClassName,
  inputClassName,
  errorClassName,
  handleChange,
  maxLength,
  required,
  error,
}) => (
  <>
    <label className={labelClassName} htmlFor={id}>
      {label}
    </label>
    <textarea
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      className={inputClassName}
      maxLength={maxLength}
      required={required}
    />
    {error && <p className={errorClassName}>{error}</p>}
  </>
);

export default Textarea;
